"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogPopup = DialogPopup;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _DialogButton = _interopRequireDefault(require("./DialogButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DialogPopup(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    children = _ref.children,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? true : _ref$open,
    onClose = _ref.onClose,
    _ref$closeText = _ref.closeText,
    closeText = _ref$closeText === void 0 ? (0, _core.translate)(variant === 'error' ? 'buttons.cancel' : 'buttons.close') : _ref$closeText,
    button = _ref.button,
    leftButton = _ref.leftButton,
    disable = _ref.disable,
    disableBackdropClick = _ref.disableBackdropClick,
    disableEscapeKeyDown = _ref.disableEscapeKeyDown,
    _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 'sm' : _ref$maxWidth;
  var onCloseClick = function onCloseClick(event, reason) {
    if (disableBackdropClick !== false && reason === 'backdropClick') {
      return;
    }
    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return;
    }
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
    open: open,
    maxWidth: maxWidth,
    fullScreen: fullScreen,
    fullWidth: fullWidth,
    scroll: "paper",
    onClose: onCloseClick,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, subtitle ? (/*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
    id: "alert-dialog-title"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6"
  }, title)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, subtitle))))) : (/*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
    id: "alert-dialog-title"
  }, title)), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
    sx: {
      paddingBottom: 2
    }
  }, children), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
    sx: {
      paddingX: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    direction: "row-reverse",
    alignContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    direction: "row-reverse",
    alignItems: "center",
    spacing: 1
  }, button && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_DialogButton["default"], Object.assign({}, button, {
    variant: variant
  })))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_DialogButton["default"], {
    variant: "close",
    text: closeText,
    disabled: disable,
    onClick: onClose
  })))), leftButton && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, !!leftButton.loading && (/*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: "1rem",
    color: "secondary"
  })), !leftButton.loading && (/*#__PURE__*/_react["default"].createElement(_DialogButton["default"], Object.assign({}, leftButton, {
    variant: "left"
  }))))))));
}